import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconCached.tsx
const OutlinedFilledCached = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z" })
});
const OutlinedCached = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z" })
});
const RoundedFilledCached = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-140q-136 0-236-98T144-470v-46l-46 46q-10 10-23 10t-23-10q-10-10-10-23.5T52-517l105-107q14-14 34-14t34 14l106 107q10 10 10 23t-10 23q-10 10-24 10t-23-10l-46-45v44q0 97 71.5 167T480-235q18 0 34.5-1.5T547-242q19-5 38.5.5T613-219q9 17 3.5 35T593-160q-27 10-55.5 15t-57.5 5Zm2-580q-19 0-35.5 2t-32.5 6q-19 4-38-1t-28-22q-10-18-4-36.5t23-25.5q28-9 56.5-13.5T482-815q135 0 235.5 98.5T818-485v44l45-45q10-11 23-10.5t23 10.5q10 10 10 23t-10 24L804-333q-14 14-33.5 14T737-333L632-439q-10-10-10.5-23.5T632-487q11-11 24.5-11t23.5 11l44 44v-40q0-96-72-166.5T482-720Z" })
});
const RoundedCached = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-140q-136 0-236-98T144-470v-46l-46 46q-10 10-23 10t-23-10q-10-10-10-23.5T52-517l105-107q14-14 34-14t34 14l106 107q10 10 10 23t-10 23q-10 10-24 10t-23-10l-46-45v44q0 97 71.5 167T480-235q18 0 34.5-1.5T547-242q19-5 38.5.5T613-219q9 17 3.5 35T593-160q-27 10-55.5 15t-57.5 5Zm2-580q-19 0-35.5 2t-32.5 6q-19 4-38-1t-28-22q-10-18-4-36.5t23-25.5q28-9 56.5-13.5T482-815q135 0 235.5 98.5T818-485v44l45-45q10-11 23-10.5t23 10.5q10 10 10 23t-10 24L804-333q-14 14-33.5 14T737-333L632-439q-10-10-10.5-23.5T632-487q11-11 24.5-11t23.5 11l44 44v-40q0-96-72-166.5T482-720Z" })
});
const SharpFilledCached = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z" })
});
const SharpCached = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z" })
});
const componentMap = {
	outlined: OutlinedCached,
	"outlined-fill": OutlinedFilledCached,
	rounded: RoundedCached,
	"rounded-fill": RoundedFilledCached,
	sharp: SharpCached,
	"sharp-fill": SharpFilledCached
};
const IconCached = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconCached };